<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/A8WCyC/tc-custom/9781504013604.jpg?1695320274612" alt="This image is the cover for the book Uncle Vampire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Uncle Vampire
      </h1>
      <p class="bookDescription body article font2">
        <b>Everyone knows vampires don’t really exist—so why are Carolyn and her sister haunted by the same nocturnal visits?</b><br/><br/> Twin sisters Honey and Carolyn have a secret: Uncle Toddy <i>must</i> be a vampire. What else could explain the fact that his nightmarish nocturnal visits are sucking the life out of their family? Honey doesn’t want to talk about it. She’s a popular, pretty cheerleader with the perfect high school life. Why can’t Carolyn pretend it isn’t happening and concentrate on good things, instead of asking questions about what happens when he knocks at her door in the middle of the night?<br/>  <br/> Both girls’ grades are suffering under the strain of keeping their secret, threatening their school activities and plans for the future. Carolyn feels like she’s going crazy, seeing things that no one else can. How can she convince Honey that she’s only trying to stop the vampire from killing them both? Her only option is to force Uncle Toddy into the one place he doesn’t want to be: the light.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cynthia D. Grant
      </h2>
      
      <p class="authorDescription body article">Cynthia D. Grant has published twelve young adult fiction novels since 1980. In 1991 she won the first PEN/Norma Klein Award, for &ldquo;an emerging voice among American writers of children&rsquo;s fiction.&rdquo; Over the years, Grant has received numerous other distinctions. Unfortunately, her Massachusetts upbringing prohibits her from showing off. She lives in the mountains outside Cloverdale, California, and has one husband, Eric Neel; two sons, Morgan Heatley-Grant and Forest Neel-Grant; two cats, Kelsey, an orange tom, and Billie, a barn cat&ndash;barracuda mix; and Mike the Wonder Dog, who packs two-hundred-plus pounds of personality into a seven-pound body.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d8ad69ca